import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
function RenderCellPrices({ row, }) {
    var _a;
    if (!row.prices) {
        return _jsx(Fragment, {});
    }
    return (_jsx(Fragment, { children: (_a = row.prices) === null || _a === void 0 ? void 0 : _a.map((price, i) => {
            if (!price)
                return;
            return _jsx("span", { children: price }, i);
        }) }));
}
export default RenderCellPrices;
//# sourceMappingURL=RenderCellPrices.js.map